<template lang="pug">
  vueCustomScrollbar.scroll-area(:settings="settings")
    table#TbGrupos.table.is-striped.is-responsive(
        style="display:flex; justify-content:center; align-items:center;"
      )
      tbody(v-if="Subgrupos.length > 0")
          tr
            td #
            td(style='text-align:center') Subgrupo
            td(colspan='5' style='text-align:center') Configuración
          tr
            td(colspan='2')
            td Color
            td Texto
            td Etiqueta
            td Botón
            td
          tr(v-for="(data, index) in Subgrupos" :key="data.id")
            td 
              a.button.is-black.is-rounded.is-small
                |{{ index + 1 }}
            td {{ data.nombre }} - {{ data.nombreCompania }}
            td
              input(type='color' disabled='' :value='data.config ? data.config.color : "No"' )
            td
              input(type='color' disabled='' :value='data.config ? data.config.texto == "white" ? "#FFFFFF" : "#000000" : "No" ' )
            td
              input(type='color' disabled='' :value='data.config ? data.config.etiqueta == "white" ? "#FFFFFF" : "#000000" : "No" ' )
            td
              input(type='color' disabled='' :value='data.config ? data.config.boton : "No"' )
            td
              b.has-text-black
                button.button.is-fullwidth.is-light.is-rounded(@click="editarSubgrupo(data.id)")
                    span.icon
                      i.fas.fa-edit
      tbody(v-else)
          tr
            td #
            td(style='text-align:center') Subgrupo
            td(colspan='5' style='text-align:center') Configuración
          tr
            td(colspan='7' style="padding:30px") No hay Subgrupos registrados para el grupo seleccionado
</template>

<script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import { mapState } from 'vuex'

  export default {
    name: 'TbGrupos',
    components: { vueCustomScrollbar },
    props: {
      Subgrupos: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        settings: {
          maxScrollbarLength: 500
        },
      }
    },
    methods: { 
      editarSubgrupo(id) {
        this.$store.commit('idEditarSubgrupo', id)
        this.$router.push('/IRGE/SCA/EditarSubgrupoIRGE')
      },

    },
    created () {
    
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos', 'idEditarSubgrupo']),
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/cuartocontrol/componentes/TbSubgrupos.vue